export enum ChannelLoudspeaker {
	Generic = 'GENERIC',
	Generic4Ohm = 'GENERIC_4_OHM',
	Generic8Ohm = 'GENERIC_8_OHM',
	Mxp1 = 'MXP_1',
	/** @deprecated */
	Mxp3 = 'MXP_3',
	Mxp3Ceiling = 'MXP_3_CEILING',
	Mxp3Wall = 'MXP_3_WALL',
	Mxp5 = 'MXP_5',
	Mxp6 = 'MXP_6',
	NotConfigured = 'NOT_CONFIGURED'
}

export const channelLoudspeakerOrder = [
	ChannelLoudspeaker.NotConfigured,
	ChannelLoudspeaker.Mxp1,
	ChannelLoudspeaker.Mxp3,
	ChannelLoudspeaker.Mxp3Ceiling,
	ChannelLoudspeaker.Mxp3Wall,
	ChannelLoudspeaker.Mxp5,
	ChannelLoudspeaker.Mxp6,
	ChannelLoudspeaker.Generic,
	ChannelLoudspeaker.Generic4Ohm,
	ChannelLoudspeaker.Generic8Ohm
];
